module.exports = __webpack_public_path__ + "img/icon-comparaison.47fe06a1.svg";